export default __webpack_public_path__ + "static/media/bg.5bb2e175.png";